import {createTooltipTranslationProviderFromNamespace} from 'features/localizedTooltips';

export const ReportsTooltipTranslationProvider =
	createTooltipTranslationProviderFromNamespace('features/reports');
